<template>
  <div class="detail_task_flow" v-loading="loading">
    <h3 class="font-bold text-medium-x mb-3">审核流程</h3>
    <el-timeline class="ml-6 mr-7">
      <el-timeline-item
        v-for="(activity, index) in activities"
        :key="index"
        :type="actionColorMap[activity.content.action]"
        :size="activity.size"
        :hide-timestamp="false"
      >
        <div class="flex items-center text-medium leading-22" v-if="activity.content.action == 2">
          <span class="mr-2 text-theme-black-850">答卷提交</span>
          <span class="text-theme-black-450">{{ activity.content.endTime }}</span>
        </div>
        <!-- 答卷审核 自动过审 -->
        <div v-else-if="activity.content.action != null && activity.content.assigneeId == null">
          <div class="flex items-center text-medium leading-22">
            <span class="mr-2 text-theme-black-850">
              答卷审核（自动过审）
            </span>
            <span class="text-theme-black-450">{{ activity.content.endTime }}</span>
          </div>
        </div>
        <!-- 答卷提交& X级审批 -->
        <template v-else>
        <div v-if="activity.content.action != null && activity.content.action != 2 && activity.content.action != 3">
          <div class="flex items-center text-medium leading-22">
            <span class="mr-2 text-theme-black-850">
              {{ activity.content.taskName }}（<span v-if="activity.content.finished">质控</span>{{ actionMap[activity.content.action] }}）
            </span>
            <span class="text-theme-black-450">{{ activity.content.endTime }}</span>
          </div>
          <div class="mt-1 flex items-center text-medium leading-22">
            <span class="text-theme-black-450">审核人：</span>
            <span class="text-theme-black-850">{{ activity.content.assigneeName }}</span>
          </div>
          <div class="mt-1 text-medium leading-22" v-if="activity.content.comment">
            <span class="text-theme-black-450">{{actionMap[activity.content.action]}}原因：</span>
            <span class="text-theme-black-850">{{ activity.content.comment }}</span>
          </div>
        </div>
        <div v-if="activity.content.action == 3">
          <div class="leading-22">{{ activity.content.taskName }}（{{ actionMap[activity.content.action] }}）</div>
        </div>
        <div v-if="activity.content.action == null">
          <div class="text-theme-black-250 leading-22">
            {{ activity.content.taskName }}（待审批）
          </div>
        </div>
        </template>
      </el-timeline-item>
      <div v-if="activities.length === 0" class="text-theme-black-450">无审核流程</div>
    </el-timeline>
    <div class="line ml-6 mr-7" :class="activities.length === 0 ? 'mt-6' : '-mt-1.5'"></div>
  </div>
</template>

<script>
import { getFullTaskFlow } from '@/api/wenjuan/multiAudit'
export default {
  name: 'DetailTaskFlow',
  props: {
    currentId: String
  },
  data() {
    return {
      //审批流使用
      activities: [
        // {
        //   content: {},
        //   size: 'normal'
        // }
      ],
      actionMap: {
        '-1': '驳回',
        0: '拒绝',
        1: '通过',
        2: '提交',
        3: '审核中',
        null: '未开始'
      },
      actionColorMap: {
        '-1': 'danger',
        0: 'danger',
        1: 'success',
        2: 'success',
        3: 'warning',
        null: 'info'
      },
      loading: false
    }
  },
  watch: {
    currentId(n) {
      this.getFullTaskFlow()
    }
  },
  methods: {
    // 获取审批流
    getFullTaskFlow() {
      this.loading = true
      getFullTaskFlow({ answerId: this.currentId })
        .then(res => {
          const data = Array.isArray(res.data?.data) ? res.data.data : []
          this.activities = data.map(item => {
            let list = {}
            list.content = item
            list.size = 'normal'
            return list
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => this.loading = false)
    },
  },
  async created() {
    await this.getFullTaskFlow()
  },
}
</script>
<style lang="scss" scoped>
.detail_task_flow {
  margin-bottom: 24px;
  h3 {
    padding-left: 20px;
    height: 20.02px;
    border-left: 4px solid;
    font-family: PingFangSC-Medium;
    color: #000000;
    line-height: 19px;
    box-sizing: border-box;
    @apply border-theme;
  }
  .container_left1_span {
    width: 56px;
    height: 22px;
  }
  .ul {
    li {
      float: left;
      width: 116px;
      height: 79px;
      margin-right: 6px;
      margin-bottom: 6px;
      background: #d8d8d8;
    }
    overflow: hidden;
  }
  .line {
    height: 1px;
    background: #e7e9eb;
  }
  ::v-deep .el-timeline {
    .el-timeline-item {
      .el-timeline-item__node--normal {
        width: 8px;
        height: 8px;
        left: 1px;
        top: 5px;
      }
      .el-timeline-item__tail {
        top: 5px;
      }
      .el-timeline-item__node--success {
        @apply bg-theme;
      }
      .el-timeline-item__node--info {
        background-color: #A4B4CD;
      }
    }
  }
}
</style>
